import _ from 'lodash';
import {Map} from 'immutable';
import { createSelector } from 'reselect';
import {REVISE_STATUS} from 'shared/globalConsts';
import {STATUS_FILTER_DRAFT, STATUS_FILTERS} from 'MyAccount/Listings/consts';
import update from 'immutability-helper';

export const getListingsPageListings = state => state.listingsPage.listings;
export const getStatusFilter = state => state.routing.location.query.statusFilter;
export const getSelectedSellerId = state => state.routing.location.query.selectedSellerId;
const getSelectedItemIds = (state) => (state.listingsPage.selectedItemIds || []);
const getListings = (state) => (state.listingsPage.listings);

export const getListingsPageListingsForRender = createSelector(
  [getListingsPageListings],
  (listingsPageListings) => {
    return _.mapValues(_.omitBy(listingsPageListings, sellerListingsData => sellerListingsData.fake), (sellerListingsData) => {
      if (sellerListingsData.itemIdByDraftId && sellerListingsData[STATUS_FILTER_DRAFT]) {
        return update(sellerListingsData, {
          [STATUS_FILTER_DRAFT]: {
            listings: {
              $apply: (listings) => listings.withMutations((listings) => {
                _.forEach(sellerListingsData.itemIdByDraftId, (itemId, draftId) => {
                  listings.remove(draftId);
                });
              })
            }
          }
        });
      }
      return sellerListingsData;
    });
  }
);

export function getListingsCounts(listingsData, countErrors = false) {
  const countsToUpdate = {};
  const counts = {
    listingsCount: listingsData.listings.count(),
  };
  if (countErrors) {
    counts.listingsWithErrorsCount = listingsData.listings.filter(listing => (listing && listing.reviseStatus === REVISE_STATUS.ERROR)).count();
  }
  _.forEach(counts, (value, key) => {
    if (listingsData.listingsLoadCompleted || value > listingsData[key]) {
      countsToUpdate[key] = value;
    } else {
      countsToUpdate[key] = listingsData[key];
    }
  });
  return countsToUpdate;
}

export const getListingsPageListingsForCurrentStatusFilter = createSelector(
  [getListingsPageListingsForRender, getSelectedSellerId, getStatusFilter],
  (listingsPageListingsForRender, selectedSellerId, statusFilter) => {
    if (statusFilter && selectedSellerId && listingsPageListingsForRender[selectedSellerId] && listingsPageListingsForRender[selectedSellerId][statusFilter]) {
      return {...listingsPageListingsForRender[selectedSellerId][statusFilter], ...getListingsCounts(listingsPageListingsForRender[selectedSellerId][statusFilter], true)};
    }
    return {listings: new Map()};
  }
);

export const isAnyListingInProgress = createSelector(
  [getListingsPageListingsForCurrentStatusFilter],
  (listingsPageListingsForCurrentStatusFilter) => {
    const {listings} = listingsPageListingsForCurrentStatusFilter;
    const predicate = listing => (listing.reviseStatus === REVISE_STATUS.RETRYING || listing.reviseStatus === REVISE_STATUS.PROCESSING);
    return listings.some(predicate);
  }
);

export const getSelectedItemsIdsArray = createSelector(
  [getSelectedItemIds, getListingsPageListingsForCurrentStatusFilter],
  (selectedItemIds, {listings}) => {
    return _.reduce(selectedItemIds, (selectedItems, selected, itemId) => {
      if (selected && listings.has(itemId)) {
        selectedItems.push(itemId);
      }
      return selectedItems;
    }, []);
  }
);

export const getSelectedListings = createSelector(
  [getListings, getSelectedItemsIdsArray, getSelectedSellerId, getStatusFilter],
  (listings, selectedItemIds, selectedSellerId, statusFilter) => {
    if (!listings || !listings[selectedSellerId]) {
      return [];
    }
    return _.filter(_.map(selectedItemIds, id => {
      return listings[selectedSellerId][statusFilter].listings.get(id);
    }));
  }
);

export const getSelectedItemsCount = createSelector(
  [getSelectedItemsIdsArray],
  (selectedItemIdsArray) => {
    return selectedItemIdsArray.length;
  }
);

export const allListingsById = createSelector(
  [getListings],
  (listings) => {
    const map = {};
    _.forEach(listings, sellerData => {
      STATUS_FILTERS.forEach(statusFilter => {
        _.assign(map, sellerData[statusFilter].listings);
      });
    });
    return map;
  }
);
